import type { GPUInstanceType } from "types/InstanceTypes";
import type { Environment } from "components/Environment/utils/types";
import { formatByteValue } from "./byteValues";

export function normalizeInstanceTypeBytes(
  instanceType: GPUInstanceType,
): GPUInstanceType {
  const memory = formatByteValue(instanceType.memory_bytes);

  return {
    ...instanceType,
    ...(memory !== undefined && { memory }),
    ...(instanceType.supported_gpus && {
      supported_gpus: instanceType.supported_gpus.map((gpu) => {
        const gpuMemory = formatByteValue(gpu.memory_bytes);
        return {
          ...gpu,
          ...(gpuMemory !== undefined && { memory: gpuMemory }),
        };
      }),
    }),
    ...(instanceType.supported_storage && {
      supported_storage: instanceType.supported_storage.map((storage) => {
        const size = formatByteValue(storage.size_bytes);
        const minSize = formatByteValue(storage.min_size_bytes);
        const maxSize = formatByteValue(storage.max_size_bytes);
        return {
          ...storage,
          ...(size !== undefined && {
            legacy_size: storage.legacy_size ?? storage.size,
            size,
          }),
          ...(minSize !== undefined && { min_size: minSize }),
          ...(maxSize !== undefined && { max_size: maxSize }),
        };
      }),
    }),
  };
}

export function normalizeEnvironmentBytes(
  environment: Environment,
): Environment {
  const diskSize = formatByteValue(environment.instance?.disk_size_bytes);

  return {
    ...environment,
    ...(environment.instance_type && {
      instance_type: normalizeInstanceTypeBytes(environment.instance_type),
    }),
    ...(environment.instance && {
      instance: {
        ...environment.instance,
        ...(diskSize !== undefined && { disk_size: diskSize }),
        ...(environment.instance.instance_type_info && {
          instance_type_info: normalizeInstanceTypeBytes(
            environment.instance.instance_type_info,
          ),
        }),
      },
    }),
  };
}
